import { combineReducers } from '@reduxjs/toolkit';
import { avDataEntryReducer } from 'components/Body/data-entry/AudioVisual/store'
import { audioVisualResultsReducer } from 'components/Body/data-entry/AudioVisualLanding/store'
import { contactResultsReducer } from 'components/Body/data-entry/ContactLanding/store'
import { contactSearchReducer } from 'components/Body/data-entry/ContactSearchSelect/store'

export const dataEntryReducer = combineReducers({
    audioVisual: avDataEntryReducer,
    audioVisualResults: audioVisualResultsReducer,
    contactResults: contactResultsReducer,
    contactSearch: contactSearchReducer
})
